// src/hooks/useBulkUpdateInventory.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import InventoryService from "../../../services/InventoryService";
import {useInventoryStore} from "../../../store/useInventoryStore";
import { INVENTORY_QUERY_KEYS } from "../useInventoryQueries";

const extractErrorMessage = (error, fallback = "خطا در بروزرسانی گروهی موجودی") => {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.detail ||
    error?.response?.data?.error ||
    fallback
  );
};

export const useBulkUpdateInventory = () => {
  const queryClient = useQueryClient();
  const resetExcelState = useInventoryStore((state) => state.resetExcelState);

  return useMutation({
    mutationKey: ["bulk-update-inventory"],
    mutationFn: async (payload) => {
      return await InventoryService.bulkUpdateInventory(payload);
    },

    onSuccess: (response) => {
      const updated = response?.updated ?? 0;
      const created = response?.created ?? 0;
      const noChange = response?.no_change ?? 0;
      const notFoundCount = Array.isArray(response?.not_found)
        ? response.not_found.length
        : 0;

      toast.success(
        `بروزرسانی: ${updated} | ایجاد: ${created} | بدون تغییر: ${noChange} | یافت نشد: ${notFoundCount}`
      );

      resetExcelState();

      queryClient.invalidateQueries({
        queryKey: [...INVENTORY_QUERY_KEYS.all, "warehouse-products"],
      });

      queryClient.invalidateQueries({
        queryKey: [...INVENTORY_QUERY_KEYS.all, "product-table"],
      });
    },

    onError: (error) => {
      toast.error(extractErrorMessage(error));
    },
  });
};


